import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@rtkwlf/pro-solid-svg-icons/faChevronRight';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { LinkButton } from '@packages/components/link-button';
import { MenuItem, Stack, Typography } from '@packages/fenrir/components';

export type WhatsNewMenuItemProps = {
  title: string;
  description: string;
  url: string;
  date: Dayjs | null;
};

export const WhatsNewMenuItem = ({
  title,
  description,
  url,
  date,
}: WhatsNewMenuItemProps) => {
  const { t } = useTranslation('ui');

  const daysAgo = date === null ? null : dayjs().diff(date, 'days');

  return (
    <MenuItem
      disableRipple
      disableTouchRipple
      sx={[
        {
          '&:hover': { backgroundColor: 'transparent', cursor: 'initial' },
        },
      ]}
    >
      <Stack
        width="100%"
        direction="row"
        gap={2}
        justifyContent="space-between"
      >
        <Stack flexBasis="fit-content" gap={1}>
          <Typography variant="h4" sx={{ textWrapMode: 'initial' }}>
            {title}
          </Typography>
          <Typography
            width="100%"
            variant="body1"
            sx={{ textWrapMode: 'initial' }}
          >
            {description}
          </Typography>
        </Stack>
        <Stack alignItems="flex-end" justifyContent="space-between">
          <Typography variant="caption">
            {daysAgo === null ? '' : t('date.daysAgo', { daysAgo })}
          </Typography>
          <LinkButton
            variant="link"
            padding="0"
            to={url}
            iconRight={<FontAwesomeIcon icon={faChevronRight} />}
          >
            {t('ui:view')}
          </LinkButton>
        </Stack>
      </Stack>
    </MenuItem>
  );
};
